import './App.css'
import MainPage from './Main/MainPage'

function App() {
  return <MainPage />;
}

export default App;